export default "__VITE_ASSET__CDZLej88__"